module.exports = __webpack_public_path__ + "img/house.b9516c7b.svg";